import { Text } from '../..';
import { ComboChartMarketHistoryRentalPricesIndustrial } from '../ComboChartMarketHistoryRentalPricesIndustrial';
import { ComboChartMarketHistorySellPricesIndustrial } from '../ComboChartMarketHistorySellPricesIndustrial';
import TitleEvaluationIndustrial from './TitleEvaluationIndustrial';
import { useApp } from '../../../../contexts';
import { translateText } from '../../../../helpers/util';

export const ChartCapRateIndustrial = ({industrialId, period=12, reloadTrigger, comparativeUniverse}) => {
    const { language, translations, userCountry } = useApp()
    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, position: 'relative' }}>
            <TitleEvaluationIndustrial title={translateText("Evolução do Mercado", language, translations, userCountry)} backgroundColor='#F3F3F3' colorTitle="#555555" />
            <Text style={{ ...styles.titleChart, backgroundColor: '#10587f', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>{translateText("Locação", language, translations, userCountry)}</Text>
            <div style={{ ...styles.divChart }}>
                <ComboChartMarketHistoryRentalPricesIndustrial comparativeUniverse={comparativeUniverse} title={translateText("Locação", language, translations, userCountry)} industrialId={industrialId} period={period} reloadTrigger={reloadTrigger} />
            </div>
            <Text style={{ ...styles.titleChart, backgroundColor: '#568C62', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>{translateText("Venda", language, translations, userCountry)}</Text>
            <div style={{ ...styles.divChart }}>
                <ComboChartMarketHistorySellPricesIndustrial comparativeUniverse={comparativeUniverse} title={translateText("Venda", language, translations, userCountry)} industrialId={industrialId} period={period} reloadTrigger={reloadTrigger}/>
            </div>
        </div>
    );
}

const styles = {
    titleChart:{
        fontSize: 16,
        marginBottom: 5,
        width: 'fit-content',
    },
    divChart: {
        // backgroundColor: "#F3F3F3",
        height: 280,
        marginBottom: 15,
        borderRadius: 15
    }
}